import React, { createRef, useEffect } from "react";
import styled, { css } from "styled-components";

import { Row } from "./box";

const Wrapper = styled(Row)`
  width: 100%;
  height: 100%;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.6);
  border-radius: 5px;
  overflow: hidden;
  background: ${({ background }) => background};
`;

const Input = styled.input`
  width: 100%;
  flex-grow: 0;
  flex-shrink: 0;
  text-align: center;
  font-size: ${({ fontSize }) => fontSize || "12px"};
  background: transparent;
  padding-left: 10px;
  padding-right: 10px;
  color: ${({ textColor }) => textColor || "#fff"};
  text-align: ${({ textAlign }) => textAlign || "center"};
  ${({ textAlign }) =>
    textAlign === "left" &&
    css`
      padding-left: 10px;
    `}
  border: 0px;
  outline: none;
  &:focus::placeholder {
    color: transparent;
  }
  &::placeholder {
    color: ${({ textColor }) => textColor || "#fff"};
    opacity: 0.6;
  }
  &:-ms-input-placeholder {
    color: ${({ textColor }) => textColor || "#fff"};
  }
  &::-ms-input-placeholder {
    color: ${({ textColor }) => textColor || "#fff"};
  }
`;

export default ({
  placeholder,
  textColor,
  background,
  textAlign,
  fontSize,
  id,
  readOnly,
  defaultValue,
}) => {
  const refInput = createRef();

  useEffect(() => {
    if (defaultValue) refInput.current.defaultValue = defaultValue;
    if (readOnly) refInput.current.readOnly = true;
  }, []);
  
  return (
    <Wrapper background={background}>
      <Input
        ref={refInput}
        type="text"
        placeholder={placeholder}
        textColor={textColor}
        textAlign={textAlign}
        fontSize={fontSize}
        id={id}
        readOnly={readOnly ? "readonly" : null}
      />
    </Wrapper>
  );
};
